export class ErrorWithLevel extends Error {
    messageLevel: string;
    tokenExpired: boolean;
    constructor(message: any, level = "warning", tokenExpired = false) {
        super(message);
        this.messageLevel = level;
        this.tokenExpired = tokenExpired
    }
}